'use client'

import { memo } from 'react'

import { useBreakpoint } from '@common/core/hooks/useBreakpoints'

import { ClassView, DesktopCardView, MethodView, RootView } from './components'
import { useCardData } from './hooks'

import styles from './Card.module.scss'

function CardComponent() {
  const { isMobile } = useBreakpoint()
  const isCompactView = isMobile
  const cardData = useCardData(isMobile)

  if (!cardData) {
    return <div className={styles.card} suppressHydrationWarning />
  }

  const { path, mobileCards } = cardData
  const methodKey = path[2]
  const isAtClassLevel = path.length === 2
  const isAtMethodLevel = path.length >= 3 && !!methodKey
  const hasMethodCards = !!mobileCards?.length

  if (isCompactView && isAtMethodLevel && hasMethodCards) {
    return (
      <div
        className={`${styles.card} ${styles.mobileMethodCardOverlay}`}
        data-vision-method-overlay
        suppressHydrationWarning
      >
        <MethodView {...cardData} />
      </div>
    )
  }

  return (
    <div className={styles.card} suppressHydrationWarning>
      {isCompactView && isAtClassLevel && hasMethodCards ? (
        <ClassView {...cardData} />
      ) : isCompactView && path.length < 2 ? (
        <RootView {...cardData} />
      ) : (
        <DesktopCardView {...cardData} />
      )}
    </div>
  )
}

export const Card = memo(CardComponent)
